module.exports = __webpack_public_path__ + "static/img/2.24e51c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zsdh/2.png
// module id = 8n+3
// module chunks = 0